/**
 * @generated SignedSource<<4bab62af5934b4970990326d16ac88a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespHeroCarousel_viewer$data = {
  readonly videoUploadToolsFeatureFlag: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubblesWrapper_viewer">;
  readonly " $fragmentType": "PdpRespHeroCarousel_viewer";
};
export type PdpRespHeroCarousel_viewer$key = {
  readonly " $data"?: PdpRespHeroCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespHeroCarousel_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespHeroCarousel_viewer",
  "selections": [
    {
      "alias": "videoUploadToolsFeatureFlag",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "videoUploadTools"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"videoUploadTools\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubblesWrapper_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "64869111803ece798612de5aa78b0ef7";

export default node;
